
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création d’une campagne Facebook Ads pour un torréfacteur | ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Boostée par une campagne Facebook, Café Thé Sens à Sens propose des cafés, thés et accessoires, alliant tradition et modernité pour séduire les amateurs.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Création d’une campagne Facebook Ads pour un torréfacteur | Agence ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Boostée par une campagne Facebook pilotée par ALEO, Café Thé Sens à Sens propose des cafés, thés et accessoires, alliant tradition et modernité pour séduire les amateurs.",
        },
      ],
    };
  },
};
